(function () {
    'use strict';

    angular
        .module('app')
        .controller('flashEditPatternForecasting', flashEditPatternForecasting);

    function flashEditPatternForecasting($scope, $rootScope, $state, $filter, ForecastingService, SeasonService,
        LinePlanService, SharedData, PatternService, PrototypeService, cfpLoadingBar, toaster, GridUtil) {
        var model = this;

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            if (userPermissionRow[0] == 16) {
                if (userPermissionRow[1] == 2) {
                    model.ForecastEdit = true;
                }
            }
        });

        if (!model.ForecastEdit) {
            $state.go('permissionDenied');
        }

        $scope.cellEditors = {
            'customCellEditor': GridUtil.intCellEditor
        };

        $scope.cellRenderers = {
            'currencyRenderer': GridUtil.currency2
        };

        $scope.valueFormatters = {
            'numberRenderer': GridUtil.number
        };

        $scope.brands = [];
        $scope.seasons = [];
        $scope.genders = [];
        $scope.divisions = [];
        $scope.lineplans = [];

        var globalPageNumber = 1;
        var globalPageSize = 50;

        $scope.windowGridHeight = function () {
            if (window.outerHeight >= 768) {
                return window.innerHeight - 315;
            } else {
                var size = $scope.totalRecords < $scope.pageSize ? $scope.totalRecords : $scope.pageSize;
                return (size * gridOptions.rowHeight) + 46;
            }
        };

        $scope.saveEdits = function (data) {

            var fcast = {
                PatternSeasonalId: rowEntity.PatternSeasonalId,
                PatternName: rowEntity.PatternName,
                StatusName: rowEntity.StatusName,
                Gender: rowEntity.Gender,
                USVolume: rowEntity.USVolume,
                NaDtcStoreVolume: rowEntity.NaDtcStoreVolume,
                NaDtcEcomVolume: rowEntity.NaDtcEcomVolume,
                ItalyVolume: rowEntity.ItalyVolume,
                CAVolume: rowEntity.CAVolume,
                EmeaOwnedVolume: rowEntity.EmeaOwnedVolume,
                EmeaDistVolume: rowEntity.EmeaDistVolume,
                EuDtcVolume: rowEntity.EuDtcVolume,
                Emea3pVolume: rowEntity.Emea3pVolume,
                AsiaVolume: rowEntity.AsiaVolume,
                CNVolume: rowEntity.CNVolume,
                HKolume: rowEntity.HKVolume,
                C4CVolume: rowEntity.C4CVolume,
                LatinAVolume: rowEntity.LatinAVolume,
                IntnlVolume: rowEntity.IntnlVolume,
                TotalVolume: rowEntity.TotalVolume,
                RetailPrice: rowEntity.RetailPrice,
                WsPrice: rowEntity.WsPrice
            };

            //send the data object to the API
            ForecastingService.updatePatternForecast(fcast).then(function (response) {
                toaster.pop({
                    type: 'success',
                    title: 'Save complete!',
                    body: 'Row data successfully saved.',
                    timeout: 5000
                });
            }, function (response) {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'There was an error performing the update: ' + response.data + ', ' + response.status,
                    timeout: 5000
                });
            });
        };

        $scope.calcTotalVolumes = function (params) {
            //cols
            var colName1 = 'TotalVolume',
                colName2 = 'IntnlVolume';

            var IntlVolume = parseVolume(params.data.AsiaVolume) +
                parseVolume(params.data.Emea3pVolume) +
                parseVolume(params.data.LatinAVolume);

            var TotVolume = parseVolume(params.data.USVolume) +
                parseVolume(params.data.NaDtcStoreVolume) +
                parseVolume(params.data.NaDtcEcomVolume) +
                parseVolume(params.data.CAVolume) +
                parseVolume(params.data.EmeaOwnedVolume) +
                parseVolume(params.data.EmeaDistVolume) +
                parseVolume(params.data.EuDtcVolume) +
                IntlVolume;

            var rowNode = gridOptions.api.getRowNode(params.node.data.PatternSeasonalId);
            rowNode.setDataValue(colName1, TotVolume);
            rowNode.setDataValue(colName2, IntlVolume);
        };

        $scope.pagingOptions = [15, 25, 50, 100];

        $scope.onBtnBeg = function () {
            $scope.pageNumber = 1;
            $scope.onPageChanged(1);
        };

        $scope.onBtnEnd = function () {
            $scope.pageNumber = $scope.totalPages;
            $scope.onPageChanged($scope.totalPages);
        };

        $scope.onBtnPrev = function (e) {
            if (e > 1) {
                e = e - 1;
                $scope.pageNumber = e;
                $scope.onPageChanged(e);
            }
        };

        $scope.onBtnNext = function (e) {
            if (e < $scope.totalPages) {
                e = e + 1;
                $scope.pageNumber = e;
                $scope.onPageChanged(e);
            }
        };

        $scope.onPageChanged = function (e) {
            globalPageNumber = e;
            $scope.flashEditPatternForecasting.$pristine = false; //forces the search to get new results
            $scope.getForecast();
        };

        $scope.onPageSizeChanged = function (e) {
            globalPageSize = e;
            globalPageNumber = 1;
            $scope.getForecast();
        };

        function valueConvert(n) {
            if (n !== '' && n !== null && n !== true && n !== false) {
                if (!isNaN(n)) {
                    return parseInt(n);
                }
            }
            if (n == null || n == '') {
                return '';
            }
            return n;
        }


        var widthXS = 65;
        var widthS = 105;
        var widthM = 160;
        var widthL = 210;
        var widthXL = 350;
        var globalRowHeight = 30;
        var widthImage = 76;

        //build gridoptions, build columns
        var gridOptions = {
            columnDefs: null,
            //rowData: response,
            rowHeight: globalRowHeight,
            enableColResize: true,
            enableFilter: false,
            enableSorting: false,
            enableServerSideSorting: true,
            paginationPageSize: globalPageSize,
            suppressContextMenu: true,
            suppressMultiSort: true,
            suppressSorting: false,
            suppressDragLeaveHidesColumns: true,
            suppressMovableColumns: true, //set to false to stop from moving colums
            suppressRowHoverClass: true,
            suppressColumnMoveAnimation: true,
            suppressColumnVirtualisation: true,
            showToolPanel: false,
            stopEditingWhenGridLosesFocus: true,
            getRowNodeId: function (data) { return data.PatternSeasonalId; },
            onCellValueChanged: function (params) {
                var oldValue = valueConvert(params.oldValue);
                var newValue = valueConvert(params.newValue);

                if (oldValue !== newValue && params.colDef.field !== 'IntnlVolume' && params.colDef.field !== 'TotalVolume') {
                    $scope.calcTotalVolumes(params);
                    $scope.saveEdits(params.data);
                }
            },

            onCellClicked: function (params) {
                if (params.colDef.patternLink) {
                    $state.go('pattern', { 'patternSeasonalId': params.data.PatternSeasonalId });
                }
            },

            onSortChanged: function (e) {
                var sortObj = gridOptions.api.getSortModel();
                $scope.searchForm.sortColumn = sortObj.length ? sortObj[0].colId : "";
                $scope.searchForm.sortDirection = sortObj.length ? sortObj[0].sort : "";

                $scope.getForecast();
            }
        };

        $scope.exportData = function () {
            //This way of exporting doesn't know what is visible in the grid so we need to format before exporting.
            //Also it will export nulls, which looks nasty.
            var tempData = [];
            for (var i in $scope.gridData) {
                var row = $scope.gridData[i];
                var temp = {};

                temp.PatternSeasonalId = row.PatternSeasonalId || "";
                temp.Name = row.Name || "";
                temp.SAPSeasonCode = row.SAPSeasonCode || "";
                temp.StatusName = row.StatusName || "";
                temp.Gender = row.Gender || "";

                if ($scope.region === "NA" || $scope.region === "ALL") {
                    temp.USVolume = row.USVolume || "";
                    temp.NaDtcStoreVolume = row.NaDtcStoreVolume || "";
                    temp.NaDtcEcomVolume = row.NaDtcEcomVolume || "";
                    temp.CAVolume = row.CAVolume || "";
                }
                if ($scope.region === "EMEA" || $scope.region === "ALL") {
                    temp.EmeaOwnedVolume = row.EmeaOwnedVolume || "";
                    temp.EmeaDistVolume = row.EmeaDistVolume || "";
                    temp.EuDtcVolume = row.EuDtcVolume || "";
                    temp.Emea3pVolume = row.Emea3pVolume || "";
                    temp.ItalyVolume = row.ItalyVolume || "";
                    temp.Emea3pVolume = row.Emea3pVolume || "";
                }
                if ($scope.region === "LAAP" || $scope.region === "ALL") {
                    temp.AsiaVolume = row.AsiaVolume || "";
                    temp.CNVolume = row.CNVolume || "";
                    temp.HKVolume = row.HKVolume || "";
                    temp.C4CVolume = row.C4CVolume || "";
                    temp.LatinAVolume = row.LatinAVolume || "";
                }

                temp.IntnlVolume = row.IntnlVolume || "";
                temp.TotalVolume = row.TotalVolume || "";
                temp.RetailPrice = row.RetailPrice || "";
                temp.WsPrice = row.WsPrice || "";
                temp.TargetPurPrice = row.TargetPurPrice || "";

                tempData.push(temp);
            }

            alasql.promise('SELECT * INTO XLSX("PLM_Pattern_Forecasting_Export.xlsx",{headers:true,sheetid:"Sheet1"}) FROM ?', [tempData])
                .then(function (data) {
                    //custom loader bar complete so we can make sure the grid is visible and rendered before hiding the loader
                    cfpLoadingBar.complete();
                }).catch(function (err) {
                });
        };

        $scope.saveEdits = function (data) {
            var fcast = {
                PatternSeasonalId: data.PatternSeasonalId,
                PatternName: data.PatternName,
                StatusName: data.StatusName,
                Gender: data.Gender,
                USVolume: data.USVolume,
                NaDtcStoreVolume: data.NaDtcStoreVolume,
                NaDtcEcomVolume: data.NaDtcEcomVolume,
                ItalyVolume: data.ItalyVolume,
                CAVolume: data.CAVolume,
                EmeaOwnedVolume: data.EmeaOwnedVolume,
                EmeaDistVolume: data.EmeaDistVolume,
                EuDtcVolume: data.EuDtcVolume,
                Emea3pVolume: data.Emea3pVolume,
                AsiaVolume: data.AsiaVolume,
                CNVolume: data.CNVolume,
                HKVolume: data.HKVolume,
                C4CVolume: data.C4CVolume,
                LatinAVolume: data.LatinAVolume,
                IntnlVolume: data.IntnlVolume,
                TotalVolume: data.TotalVolume,
                RetailPrice: data.RetailPrice,
                WsPrice: data.WsPrice
            };

            ForecastingService.updatePatternForecast(fcast).then(function (response) {
                
            }, function (response) {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'There was an error performing the update: ' + response.data + ', ' + response.status,
                    timeout: 5000
                });
            });
        };

        var FCols = [
            'USVolume', 'NaDtcStoreVolume', 'NaDtcEcomVolume', 'ItalyVolume', 'CAVolume', 'EmeaOwnedVolume', 'EmeaDistVolume', 'EuDtcVolume', 'Emea3pVolume', 'AsiaVolume', 'CNVolume', 'HKVolume', 'C4CVolume', 'LatinAVolume', 'IntnlVolume', 'Launch',
        ];

        $scope.columnsSet = function (arr, tf) {
            for (var i = 0; i < arr.length; i++) {
                gridOptions.columnApi.setColumnVisible(arr[i], tf);
            }
        };

        $scope.setRegionVisibility = function (region) {
            $scope.region = region;
            switch (region) {
            case "NA":
                $scope.columnsSet(FCols, false);
                $scope.columnsSet(['USVolume', 'NaDtcStoreVolume', 'NaDtcEcomVolume', 'CAVolume'], true);
                break;
            case "EMEA":
                $scope.columnsSet(FCols, false);
                $scope.columnsSet(['EmeaOwnedVolume', 'EmeaDistVolume', 'EuDtcVolume', 'ItalyVolume', 'Emea3pVolume'], true);
                break;
            case "LAAP":
                $scope.columnsSet(FCols, false);
                $scope.columnsSet(['AsiaVolume', 'CNVolume', 'HKVolume', 'C4CVolume', 'LatinAVolume'], true);
                break;
            case "ALL":
                $scope.columnsSet(FCols, true);
                break;
            default:
                $scope.columnsSet(FCols, true);
            }
        };

        function parseVolume(volumeVal) {
            if (volumeVal == NaN || volumeVal == null || volumeVal == "") {
                volumeVal = 0;
            }
            return parseFloat(volumeVal);
        };

        //Upload functions
        $scope.massForecastMetaData = {};

        $scope.selectDoc = function (e) {
            if (e.files.length > 0)
                uploadDoc(e.files[0], 'browse');
        };

        $scope.addDoc = function (file) {
            uploadDoc(file.file, 'dragdrop');
        };

        function clearFileSelect() {
            document.getElementById('file').value = null;
        }

        function uploadDoc(file, source) {
            var ext = file.name.substr(file.name.lastIndexOf('.') + 1)
            if (ext != "xls" && ext != "xlsx") {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: "Please upload an Excel file (.xls or .xlsx)",
                    timeout: 5000
                });
                clearFileSelect();
                return;
            }

            ForecastingService.uploadMassPatternForecastDocument(file)
                .then(function (response) {
                    toaster.pop({
                        type: 'success',
                        title: 'Forecasting upload complete!',
                        body: 'You will be notified by email when processing is complete.',
                        timeout: 5000
                    });
                    clearFileSelect();
                }, function (error, status) {
                    toaster.pop({
                        type: 'error',
                        title: 'Forecasting upload failed',
                        body: 'Contact system administrator.',
                        timeout: 5000
                    });
                    clearFileSelect();
                });

            $scope.showSearchForm = true;
            $scope.showGrid = false;
        }

        function setScopeLevelSearchInfo(response) {

            $scope.totalRecords = response.totalRecords;
            $scope.pageSize = response.pageSize;
            $scope.pageNumber = response.currentPage;
            $scope.totalPages = response.totalPages;

            $scope.lastRecord = $scope.pageNumber == $scope.totalPages
                ? $scope.totalRecords
                : $scope.pageNumber * $scope.pageSize;

            $scope.firstRecord = $scope.pageNumber == $scope.totalPages
                ? (($scope.pageNumber - 1) * $scope.pageSize) + 1
                : $scope.lastRecord - $scope.pageSize + 1;

            $scope.columnDefs = $scope.getColumnDefs(response);
        }

        function setGridSorting(columnDefs) {

            var colId = $scope.searchForm.sortColumn;
            var sort = $scope.searchForm.sortDirection;

            GridUtil.setSort(columnDefs, colId, sort);
        }

        function renderGrid(gridDiv, columnDefs, searchResults) {
            gridOptions.columnDefs = columnDefs;

            if (gridDiv.children.length == 0) {
                new agGrid.Grid(gridDiv, gridOptions);
            } else {
                gridOptions.api.setColumnDefs(gridOptions.columnDefs);
            }

            gridOptions.api.setRowData(searchResults);
            gridOptions.api.hideOverlay();
        }

        $scope.getColumnDefs = function (searchResponse) {
            var columnDefs = [];
            searchResponse.columnGroups.totalColumns = searchResponse.totalColumns;

            angular.forEach(searchResponse.columnGroups,
                function (colGroup) {
                    angular.forEach(colGroup.columns,
                        function (col) {

                            if (col.cellEditor) {
                                col.cellEditor = $scope.cellEditors[col.cellEditor];
                            }

                            if (col.cellRenderer) {
                                col.cellRenderer = $scope.cellRenderers[col.cellRenderer];
                            }

                            if (col.valueFormatter) {
                                col.valueFormatter = $scope.valueFormatters[col.valueFormatter];
                            }

                            columnDefs.push(col);
                        });
                });

            return columnDefs;
        };

        $scope.getForecast = function (exportResults) {
            if ($scope.flashEditPatternForecasting.$invalid) {
                return;
            }
            var searchForm = {
                brandId: $scope.searchForm.brandId ? $scope.searchForm.brandId : null,
                seasonId: $scope.searchForm.seasonId ? $scope.searchForm.seasonId : null,
                projectName: $scope.searchForm.projectName ? $scope.searchForm.projectName : null,
                patternSeasonalId: $scope.searchForm.patternSeasonalId ? $scope.searchForm.patternSeasonalId : null,
                patternName: $scope.searchForm.patternName ? $scope.searchForm.patternName : null,
                statusId: $scope.searchForm.statusId ? $scope.searchForm.statusId : null,
                genderKey: $scope.searchForm.genderKey ? $scope.searchForm.genderKey : null,
                divisionKey: $scope.searchForm.divisionKey ? $scope.searchForm.divisionKey : null,
                divisionName: $scope.searchForm.divisionName ? $scope.searchForm.divisionName : null,
                stockNum: $scope.searchForm.stockNum ? $scope.searchForm.stockNum : null,
                LinePlanId: $scope.searchForm.LinePlanId ? $scope.searchForm.LinePlanId : null,
                pageNumber: exportResults ? '1' : globalPageNumber,
                pageSize: exportResults ? $scope.totalRecords : globalPageSize,
                sortColumn: $scope.searchForm.sortColumn,
                sortDirection: $scope.searchForm.sortDirection
            };

            //start page loader
            cfpLoadingBar.start();
            model.exportResults = exportResults;
            ForecastingService.getPatternForecastList(searchForm).then(function (response) {
                if (!response || response.results.length === 0) {
                    cfpLoadingBar.complete();
                    toaster.pop({ type: 'alert', title: 'Warning!', body: 'No forecast data was found matching this search criteria.', timeout: 5000 });
                } else {
                    if (!model.exportResults) {
                        var gridDiv = document.querySelector('#myGrid');

                        setScopeLevelSearchInfo(response);

                        setGridSorting($scope.columnDefs);

                        renderGrid(gridDiv, $scope.columnDefs, response.results);

                        if (!$scope.region)
                            $scope.region = "NA";
                        $scope.setRegionVisibility($scope.region);

                        //show the grid, hide search form, mark page complete on load
                        $scope.showGrid = true;
                        $scope.showSearchForm = false;

                        //custom loader bar complete so we can make sure the grid is visible and rendered before hiding the loader
                        cfpLoadingBar.complete();

                        //set search page to pristine so if we go back and refine, but change nothing, we can come back to the grid right away
                        $scope.flashEditPatternForecasting.$setPristine();
                    } else {
                        $scope.gridData = response.results;
                        $scope.exportData();
                    }
                }

            }, function (error, status) {
                    toaster.pop({ type: 'error', title: 'Error!', body: 'There was an error retrieving Forecasts. Please contact the system administrator', timeout: 5000 });
                });
        };

        //!!!! Start !!!!!
        //getPage();


        function getPage() {
            SharedData.getUserDefaults().then(function (response) {

                if (response) {
                    $scope.searchForm = {};
                    $scope.brands = response.brands;
                    $scope.seasons = response.seasons;
                    $scope.searchForm.brandId = response.brandId;
                    $scope.searchForm.seasonId = response.seasonId;
                    $scope.searchForm.divisionKey = response.divisionKey;
                    $scope.getLinePlans($scope.searchForm.brandId, $scope.searchForm.seasonId, 0);
                }
                else {
                    console.log('Error getting shared data');
                }
            });

            $scope.showSearchForm = true;
            $scope.showGrid = false;
            getGenders();
            getDivisions();
        };

        //fill the Seasons DDL after a user selects a brand
        $scope.getSeason = function (brandId) {

            if (brandId) {
                SeasonService.getSeasonsByBrand(brandId).then(function (response) {
                    if (response) {
                        $scope.seasons = response;
                        $scope.noBrandSelected = false;
                    }
                });

            }
            else {
                $scope.seasons.length = 0;
                var season = { SeasonId: 0, Description: '-- Select Season --' };
                $scope.seasons.push(season);
                $scope.noBrandSelected = true;
            }
        };

        function getGenders() {
            //populate gender
            PatternService.getGenders("", 0).then(function (response) {
                if (response) {
                    $scope.genders = response;
                }
            });
        }

        function getDivisions() {
            //populate division
            PrototypeService.getDivisions(0).then(function (response) {
                if (response) {
                    $scope.divisions = response;
                }
            });
        }

        $scope.getLinePlans = function (brandId, seasonId) {
            if (brandId && brandId > 0 && seasonId && seasonId > 0) {

                LinePlanService.getLinePlansByBrandSeason(brandId, seasonId, 0).then(function (response) {
                    if (response) {
                        $scope.lineplans = response;
                    }
                });
            }
        };

        $scope.toggleSearchAndResults = function () {
            if ($scope.showGrid) {
                $scope.showGrid = false;
                $scope.showSearchForm = true;
            } else {
                $scope.showGrid = true;
                $scope.showSearchForm = false;
            }
        };

        cfpLoadingBar.complete();

    }
})();
